<div class="mt-2 -mr-4 flex flex-row gap-1">
  <div class="flex flex-col content-center items-end gap-1">
    @for (row of rows(); track row.key) {
      <nsp-input-label
        [label]="row.label"
        class="h-10.5"
        [required]="row?.required ?? false"
        [id]="row.key"
      />
    }
  </div>
  <div class="flex min-w-0 flex-1 flex-row overflow-hidden">
    @let entries = data().entries;
    @for (
      entry of object.values(entries);
      let entryIndex = $index;
      track entryIndex
    ) {
      @let disabled =
        !entry?.fuelType?.value?.name || !entry?.isoFuelGrade?.value?.name;
      <div class="flex min-w-0 flex-1 basis-0 flex-col gap-1">
        @for (row of rows(); track row.key) {
          @let id = `entries-${row.key}-${entryIndex}`;
          @let input = entry?.[row.key];
          @if (row.key === 'fuelType') {
            <nsp-select-input
              class="w-full min-w-0"
              [id]="id"
              [name]="id"
              [options]="fuelTypeOptionsByRow()[entryIndex]"
              [showClear]="true"
              (selectionChanged)="onFuelTypeChanged(entryIndex)"
              [value]="entry?.fuelType?.value"
              [ngModel]="entry?.fuelType?.value"
            />
          } @else if (row.key === 'isoFuelGrade') {
            <nsp-select-input
              class="w-full min-w-0"
              [id]="id"
              [name]="id"
              [pTooltip]="
                getIsoFuelGradeTooltip(disabled, input, row?.required ?? false)
              "
              tooltipPosition="top"
              tooltipStyleClass="text-white"
              [required]="row.required ?? false"
              [options]="getIsoGradeOptionsByRow(entryIndex)"
              [showClear]="true"
              [value]="entry?.isoFuelGrade?.value"
              [ngModel]="entry?.isoFuelGrade?.value"
              [disabled]="!entry?.fuelType?.value"
              (selectionChanged)="
                onFuelISOGradeChanged(entryIndex, $event.value)
              "
            />
          } @else {
            <nsp-number-input
              class="w-full min-w-0"
              [id]="id"
              [name]="id"
              [pTooltip]="
                !disabled && input?.error && input?.status === 'INVALID'
                  ? input?.error
                  : ''
              "
              tooltipPosition="top"
              tooltipStyleClass="text-white"
              [required]="row?.required ?? false"
              [ngModel]="input?.value"
              [invalidOverride]="
                !disabled &&
                input?.status === 'INVALID' &&
                (input?.min !== undefined || input?.max !== undefined)
              "
              (ngModelChange)="
                onNumberValueChanged(
                  entryIndex,
                  row.key,
                  $event,
                  input?.min,
                  input?.max,
                  input?.status
                )
              "
              [disabled]="disabled"
            />
          }
        }
      </div>
    }
  </div>

  <div class="flex flex-col self-stretch">
    <p-button
      class="flex-1 self-stretch transition-opacity hover:opacity-100"
      styleClass="-mr-4 h-full w-2.5 min-w-0 rounded-b-none!"
      (onClick)="addEntry()"
      severity="secondary"
    >
      <nsp-icon [name]="IconNames.Plus" />
    </p-button>

    <p-button
      class="flex-1 self-stretch transition-opacity hover:opacity-100"
      styleClass="-mr-4 h-full w-2.5 min-w-0 rounded-t-none!"
      [disabled]="entries.length === 1"
      (onClick)="removeEntry()"
      severity="secondary"
    >
      <nsp-icon [name]="IconNames.Minus" />
    </p-button>
  </div>
</div>
